import React, { useState, useEffect } from "react";

import { Line, Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";
import { useSelector } from "react-redux";
import moment from "moment";
import ChartState from "./_shared/ChartState";
import { ACCENT, GRID_COLOR } from "./_shared/chartTheme";

const DiamondReportsClicksComp = ({
  globalDiamonds,
  isApplyFilter,
  mainForDealer,
}) => {
  const { t } = useTranslation();
  /*React Binding Starts*/
  const loginDetials = useSelector((state) => state.loginReducer);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [diamondClicksLabels, setdiamondClicksLabels] = useState([]);
  const [DiamondClicksYAxisList, setDiamondClicksYAxisList] = useState([]);
  const [chartType, setChartType] = useState("line");

  /*React Binding Ends*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          handleLoadExtendedDiamondChartReports(
            loginDetials.loginDetials.responseData.dealerId,
            mainForDealer
          );
        }
      }
    }
  }, [isApplyFilter]);

  /*API Binding Starts*/

  const handleLoadExtendedDiamondChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: "0",
        forDealer: "3",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        reportName: "ExtDiamondChrt",
      };
      setLoadChartReportsLoading(true);

      ReportsDiamondService.LoadExtendedDiamondChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondClicksList = responseData.DiamondClicks;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              // Sort chronologically ascending — the API returns them in reverse.
              var sortedList = [...DiamondClicksList].sort(
                (a, b) => moment(a.Date) - moment(b.Date)
              );
              setdiamondClicksLabels(sortedList.map((item) => item.Date));
              setDiamondClicksYAxisList(sortedList.map((item) => item.CNT));
            }
          } else {
            setDiamondClicksYAxisList([]);
          }
        })
        .catch((error) => {
          setDiamondClicksYAxisList([]);
          setLoadChartReportsLoading(false);
          setdiamondClicksLabels([]);
        });
    } catch (error) {
      setDiamondClicksYAxisList([]);
      setLoadChartReportsLoading(false);
      setdiamondClicksLabels([]);
    }
  };
  /*API Binding Ends*/

  const chartJsData = {
    labels: diamondClicksLabels,
    datasets: [
      {
        label: t("Clicks"),
        data: DiamondClicksYAxisList,
        backgroundColor:
          chartType === "bar" ? ACCENT : "rgba(59, 91, 219, .15)",
        borderColor: ACCENT,
        borderWidth: 2,
        fill: chartType === "line",
        tension: 0.35,
        pointRadius: chartType === "line" ? 2 : 0,
        borderRadius: 3,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      x: { grid: { display: false } },
      y: { grid: { color: GRID_COLOR }, beginAtZero: true },
    },
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <div className="edr-panel-head">
          <label>
            <b> {t("Diamond Clicks")} </b>
          </label>
          <div className="edr-seg">
            <button
              className={chartType === "line" ? "edr-on" : ""}
              onClick={() => setChartType("line")}
            >
              {t("Line")}
            </button>
            <button
              className={chartType === "bar" ? "edr-on" : ""}
              onClick={() => setChartType("bar")}
            >
              {t("Bar")}
            </button>
          </div>
        </div>
        <div className="chart__section">
          {!LoadChartReportsLoading && diamondClicksLabels.length > 0 ? (
            <div className="edr-chartwrap edr-tall">
              {chartType === "line" ? (
                <Line data={chartJsData} options={options} />
              ) : (
                <Bar data={chartJsData} options={options} />
              )}
            </div>
          ) : (
            <ChartState loading={LoadChartReportsLoading} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsClicksComp;
